import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingConfig } from './types/mailing-config.type';

/**
 * Retrieves the mailing configuration for a given mailing ID.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param mailingId - The unique identifier of the mailing to fetch the configuration for.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing the {@link MailingConfig}.
 * @throws Will throw an error if the request fails.
 */
export const getMailingConfig = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingConfig>>(formatString(Uri.mailing.getMailingConfig, mailingId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
